import { render, staticRenderFns } from "./search-database.vue?vue&type=template&id=42318a60&"
import script from "./search-database.vue?vue&type=script&lang=js&"
export * from "./search-database.vue?vue&type=script&lang=js&"
import style0 from "./search-database.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports